<div class="v4-layout-content h-full">
  <nz-tabset
    nzSize="large"
    [nzCanDeactivate]="canTabDeactivate"
    [(nzSelectedIndex)]="tabIndex"
    (nzSelectedIndexChange)="onTabIndexChange($event)"
  >
    <nz-tab [nzTitle]="'word.house' | translate">
      <!-- <ng-template [ngTemplateOutlet]="houseContent"></ng-template> -->
    </nz-tab>
    <nz-tab [nzTitle]="'word.house_type' | translate">
      <!-- <ng-template [ngTemplateOutlet]="houseTypeContent"></ng-template> -->
    </nz-tab>
  </nz-tabset>
  <div class="panel-content" #scrollContainer>
    <div class="v4-filter-list justify-between py-[30px]" [formGroup]="form">
      <div class="v4-filter-item flex-1">
        <v4-widget-input [placeholder]="'word.search' | translate" formControlName="keyword"></v4-widget-input>
      </div>
      <div class="v4-filter-item hide-mark">
        <div class="v4-filter-style">
          <host-select
            class="w-[100px] text-center"
            [placeholder]="'word.group' | translate"
            formControlName="group_id"
            [listOfOption]="optionsOfGroup"
          ></host-select>
        </div>
      </div>
      <ng-container *ngIf="tabIndex === 1">
        <div class="v4-filter-item hide-mark">
          <host-condition-switch-picker
            class="v4-filter-style"
            [listOfOption]="optionsOfTag"
            formControlName="house_tag"
          ></host-condition-switch-picker>
          <!-- <nz-select
              nzPlaceHolder="Tag"
              formControlName="house_tag_id"
              [nzOptions]="optionsOfTag"
              [nzDropdownMatchSelectWidth]="false"
              nzMode="multiple"
            ></nz-select> -->
        </div>
      </ng-container>
    </div>
    <ng-container
      *ngIf="
        (tabIndex === 0 && listOfHostexHouses.length) || (tabIndex === 1 && listOfHostexHouseTypes.length);
        else emptyHouses
      "
    >
      <div class="list">
        <ng-container>
          <ng-template
            [ngTemplateOutlet]="houseCardTpl"
            [ngTemplateOutletContext]="{ $implicit: groupedHostexList?.seperate }"
          ></ng-template>
        </ng-container>

        <!-- in room type -->
        <ng-container *ngIf="groupedHostexList?.in_room_type">
          <div class="mb-6 cursor-pointer" (click)="displayPropertiesInRoomType = !displayPropertiesInRoomType">
            <span class="text-xs text-c-l2">
              {{
                "channel-house_relation-left_panel_html_房型中的房间"
                  | translate: { number: groupedHostexList?.in_room_type.length }
              }}
              <!-- {{ groupedHostexList?.in_room_type.length }} more properties in the room type -->
            </span>
            <img
              class="w-[9px] ml-1"
              [class.rotate-180]="displayPropertiesInRoomType"
              src="/assets/v4/icon-arrow-down.svg"
              alt=""
            />
            <!-- <i nz-icon nzTheme="outline" [nzType]="displayPropertiesInRoomType ? 'up' : 'down'"></i> -->
          </div>
          <ng-container *ngIf="displayPropertiesInRoomType">
            <ng-template
              [ngTemplateOutlet]="houseCardTpl"
              [ngTemplateOutletContext]="{ $implicit: groupedHostexList?.in_room_type }"
            ></ng-template>
          </ng-container>
        </ng-container>
      </div>

      <ng-template #houseCardTpl let-list>
        <div
          class="hostex-card"
          [class.selected]="hostex.id === selectedItem?.id"
          (click)="onClickHostexItem(hostex)"
          *ngFor="let hostex of list; let i = index; trackBy: trackById"
        >
          <v4-widget-card [title]="hostex.title">
            <div class="card_content" [class.pt-4]="!hostex?.card?.length">
              <div #houseCard class="v4-layout-list-item" *ngFor="let house of hostex.card; trackBy: trackByLinkId">
                <host-house-relation-house-card [houseInfo]="house">
                  <div class="house-card_btns">
                    <button
                      nz-button
                      (click)="
                        $event.stopPropagation();
                        onUnlink.emit({
                          node: houseCard,
                          data: { from: hostex, house: house }
                        })
                      "
                    >
                      {{ "channel-house_relation-left_panel_html_解除关联" | translate }}
                      <!-- Unlink -->
                    </button>
                  </div>
                </host-house-relation-house-card>
              </div>
              <div class="link-btn" #houseLinkNode>
                {{ "channel-house_relation-left_panel_html_点击关联" | translate }}
                <!-- Click on "Link" to link with this property -->
              </div>
            </div>
          </v4-widget-card>
        </div>
      </ng-template>
    </ng-container>

    <ng-template #emptyHouses>
      <div class="v4-layout-empty mt-32">
        <div class="v4-layout-empty-img"></div>
        <div class="v4-layout-empty-content">
          <div class="v4-layout-empty-title">
            {{
              (tabIndex === 0
                ? "channel-house_relation_left_html_未创建房间"
                : "channel-house_relation_left_html_未创建房型"
              ) | translate
            }}
          </div>
        </div>
        <div class="v4-layout-empty-footer">
          <button nz-button nzType="primary" nzSize="large" (click)="onCreate()">
            {{
              (tabIndex === 0
                ? "channel-house_relation_left_html_创建房间"
                : "channel-house_relation_left_html_创建房型"
              ) | translate
            }}
          </button>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<host-link-room-type-note
  *ngIf="displayLinkRtNote"
  (onClose)="onCloseLinkRtNote()"
  (onFinish)="onFinishLinkRtNote()"
></host-link-room-type-note>
